export default "/images/logo-11.png?b50dd626c4b81bcf1e867e26fb5bbf3b";